"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spottedSortOption = void 0;
exports.spottedSortOption = [
    {
        id: 1,
        name: 'Newest',
        sort: { _id: -1 },
        esSort: [
            { date_create: 'desc' }
        ]
    },
    {
        id: 2,
        name: 'Popular',
        sort: { view_count: -1, 'vote.up.count': -1, comment_count: -1, date_create: -1 },
        esSort: [
            { view_count: 'desc' }, { 'vote.up.count': 'desc' }, { comment_count: 'desc' }, { date_create: 'desc' }
        ]
    }
];
